// // store/loaderSlice.js
// import { createSlice } from "@reduxjs/toolkit";

// const loaderSlice = createSlice({
//     name: "loader",
//     initialState: { isLoading: false },
//     reducers: {
//         showLoader: (state) => {
//             state.isLoading = true;
//         },
//         hideLoader: (state) => {
//             state.isLoading = false;
//         },
//     },
// });

// export const { showLoader, hideLoader } = loaderSlice.actions;
// export default loaderSlice.reducer;


import { createSlice } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
    name: "loader",
    initialState: {
        requestCount: 0,
        isLoading: false
    },
    reducers: {

        showLoader: (state) => {
            state.requestCount += 1;
            state.isLoading = true;
        },

        hideLoader: (state) => {
            state.requestCount -= 1;

            if (state.requestCount <= 0) {
                state.isLoading = false;
                state.requestCount = 0;
            }
        },

        resetLoader: (state) => {
            state.requestCount = 0;
            state.isLoading = false;
        }
    },
});

export const { showLoader, hideLoader, resetLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
